var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: [
        "section3",
        (_vm.current_match && _vm.current_match.status) !== 1
          ? "btn-disabled"
          : "",
      ],
    },
    [
      _c("div", { staticClass: "filter-and-results" }, [
        _c("div", { class: ["contest-result"] }, [
          _vm.current_match &&
          _vm.current_match.isLoaded &&
          _vm.selected_match_contests.length
            ? _c("span", { staticClass: "count" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.selected_match_contests.length
                        ? _vm.contest_count
                        : _vm.translations.no
                    ) +
                    "\n        " +
                    _vm._s(_vm.translations.contests_found) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.current_match &&
          _vm.current_match.isLoaded &&
          _vm.selected_match_contests.length
            ? _c("span", { staticClass: "result-text" }, [
                _vm._v(
                  _vm._s(_vm.translations.sorted_by) +
                    ": " +
                    _vm._s(_vm.getAppliedSortingOrder())
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        (_vm.current_match && _vm.current_match.status) === 1
          ? _c("div", { staticClass: "more-filter" }, [
              _c(
                "div",
                {
                  class: [
                    "filter-head",
                    _vm.filters.filter_applied || true ? "active" : "",
                  ],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openFilterSection.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon-filter" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "filter-txt" }, [
                    _vm._v(_vm._s(_vm.translations.sort_filter_label)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.showFilterPopUp
                ? _c("div", { staticClass: "filter-body" }, [
                    _c("div", { staticClass: "filter-tab-content" }, [
                      _c("div", { staticClass: "filter-wrap" }, [
                        _c("div", { staticClass: "head" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.translations.sort_filter_label)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn reset",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.resetFilter(true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.translations.reset) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "body" }, [
                          _c("div", { staticClass: "content-wrapper" }, [
                            _c("div", { staticClass: "tab-section" }, [
                              _c("ul", [
                                _c(
                                  "li",
                                  {
                                    class: [
                                      "sub-filter",
                                      _vm.filterElemsConfig.sort
                                        ? "active"
                                        : "",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        ;(_vm.filterElemsConfig.sort = true),
                                          (_vm.filterElemsConfig.ef = false),
                                          (_vm.filterElemsConfig.ppool = false),
                                          (_vm.filterElemsConfig.platform = false),
                                          (_vm.filterElemsConfig.spots = false)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.translations.sort_by) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: [
                                      "sub-filter",
                                      _vm.filterElemsConfig.ppool
                                        ? "active"
                                        : "",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        ;(_vm.filterElemsConfig.sort = false),
                                          (_vm.filterElemsConfig.ef = false),
                                          (_vm.filterElemsConfig.ppool = true),
                                          (_vm.filterElemsConfig.platform = false),
                                          (_vm.filterElemsConfig.spots = false)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.translations.prize_pool) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: [
                                      "sub-filter",
                                      _vm.filterElemsConfig.spots
                                        ? "active"
                                        : "",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        ;(_vm.filterElemsConfig.sort = false),
                                          (_vm.filterElemsConfig.ef = false),
                                          (_vm.filterElemsConfig.ppool = false),
                                          (_vm.filterElemsConfig.platform = false),
                                          (_vm.filterElemsConfig.spots = true)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.translations.spots_label) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: [
                                      "sub-filter",
                                      _vm.filterElemsConfig.platform
                                        ? "active"
                                        : "",
                                    ],
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        ;(_vm.filterElemsConfig.sort = false),
                                          (_vm.filterElemsConfig.ef = false),
                                          (_vm.filterElemsConfig.ppool = false),
                                          (_vm.filterElemsConfig.platform = true),
                                          (_vm.filterElemsConfig.spots = false)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.translations.platform) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sub-filter-section" }, [
                              _vm.filterElemsConfig.sort
                                ? _c(
                                    "section",
                                    {
                                      staticClass:
                                        "extended-section sort-section",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "sort-tab-content" },
                                        [
                                          _c("div", { staticClass: "body" }, [
                                            _c("ul", [
                                              _c(
                                                "li",
                                                {
                                                  class: [
                                                    "sorting-list",
                                                    _vm.sort_by.prop === "ar" &&
                                                    _vm.sort_by.order === "desc"
                                                      ? "active"
                                                      : "",
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.applySort({
                                                        prop: "ar",
                                                        order: "desc",
                                                      })
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.translations
                                                          .aret_h_l
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  class: [
                                                    "sorting-list",
                                                    _vm.sort_by.prop ===
                                                      "roip" &&
                                                    _vm.sort_by.order === "desc"
                                                      ? "active"
                                                      : "",
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.applySort({
                                                        prop: "roip",
                                                        order: "desc",
                                                      })
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.translations
                                                          .aretper_h_l
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  class: [
                                                    "sorting-list",
                                                    _vm.sort_by.prop === "mp" &&
                                                    _vm.sort_by.order === "desc"
                                                      ? "active"
                                                      : "",
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.applySort({
                                                        prop: "mp",
                                                        order: "desc",
                                                      })
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.translations
                                                          .aprof_h_l
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  class: [
                                                    "sorting-list",
                                                    _vm.sort_by.prop === "tp" &&
                                                    _vm.sort_by.order === "desc"
                                                      ? "active"
                                                      : "",
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.applySort({
                                                        prop: "tp",
                                                        order: "desc",
                                                      })
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.translations
                                                          .price_h_l
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  class: [
                                                    "sorting-list",
                                                    _vm.sort_by.prop === "ef" &&
                                                    _vm.sort_by.order === "desc"
                                                      ? "active"
                                                      : "",
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.applySort({
                                                        prop: "ef",
                                                        order: "desc",
                                                      })
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.translations
                                                          .entry_h_l
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  class: [
                                                    "sorting-list",
                                                    _vm.sort_by.prop === "ef" &&
                                                    _vm.sort_by.order === "asc"
                                                      ? "active"
                                                      : "",
                                                  ],
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.applySort({
                                                        prop: "ef",
                                                        order: "asc",
                                                      })
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.translations
                                                          .entry_l_h
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filterElemsConfig.ppool
                                ? _c(
                                    "section",
                                    {
                                      staticClass:
                                        "extended-section prize-section",
                                    },
                                    [
                                      _c("div", { staticClass: "tag" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translations
                                                .select_entry_range
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "form",
                                          {
                                            staticClass: "range-form",
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group min-range",
                                              },
                                              [
                                                _c("input", {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "number",
                                                    name: "pricerage",
                                                    min: _vm.filter_options
                                                      .total_price_slider[0],
                                                    max: _vm.filter_options
                                                      .total_price_slider[1],
                                                    pattern: "\\d*",
                                                  },
                                                  domProps: {
                                                    value: _vm.price_range_l,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      _vm.price_range_l =
                                                        +$event.target.value
                                                    },
                                                    keydown: function (e) {
                                                      return (
                                                        _vm.invalidChars.includes(
                                                          e.key
                                                        ) && e.preventDefault()
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group max-range",
                                              },
                                              [
                                                _c("input", {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "number",
                                                    name: "pricerage",
                                                    min: _vm.filter_options
                                                      .total_price_slider[0],
                                                    max: _vm.filter_options
                                                      .total_price_slider[1],
                                                    pattern: "\\d*",
                                                  },
                                                  domProps: {
                                                    value: _vm.price_range_h,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      _vm.price_range_h =
                                                        +$event.target.value
                                                    },
                                                    keydown: function (e) {
                                                      return (
                                                        _vm.invalidChars.includes(
                                                          e.key
                                                        ) && e.preventDefault()
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "slidecontainer" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "price-range-max price-range",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.translations.max)
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "vue-slider",
                                            _vm._b(
                                              {
                                                staticStyle: {
                                                  margin: "0 auto",
                                                  height: "150px",
                                                },
                                                attrs: {
                                                  "tooltip-formatter":
                                                    _vm.formatter,
                                                  direction: "btt",
                                                },
                                                model: {
                                                  value: _vm.priceRange,
                                                  callback: function ($$v) {
                                                    _vm.priceRange = $$v
                                                  },
                                                  expression: "priceRange",
                                                },
                                              },
                                              "vue-slider",
                                              _vm.priceRangeOptions,
                                              false
                                            )
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "price-range-min price-range",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.translations.min)
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filterElemsConfig.spots
                                ? _c(
                                    "section",
                                    {
                                      staticClass:
                                        "extended-section prize-section",
                                    },
                                    [
                                      _c("div", { staticClass: "tag" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.translations.select_spot_range
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "form",
                                          {
                                            staticClass: "range-form",
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group min-range spot-range",
                                              },
                                              [
                                                _c("input", {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "number",
                                                    name: "pricerage",
                                                    min: _vm.filter_options
                                                      .total_spots_slider[0],
                                                    max: _vm.filter_options
                                                      .total_spots_slider[1],
                                                    pattern: "\\d*",
                                                  },
                                                  domProps: {
                                                    value: _vm.spots_range_l,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      _vm.spots_range_l =
                                                        +$event.target.value
                                                    },
                                                    keydown: function (e) {
                                                      return (
                                                        _vm.invalidChars.includes(
                                                          e.key
                                                        ) && e.preventDefault()
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group max-range spot-range",
                                              },
                                              [
                                                _c("input", {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "number",
                                                    name: "pricerage",
                                                    min: _vm.filter_options
                                                      .total_spots_slider[0],
                                                    max: _vm.filter_options
                                                      .total_spots_slider[1],
                                                    pattern: "\\d*",
                                                  },
                                                  domProps: {
                                                    value: _vm.spots_range_h,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      _vm.spots_range_h =
                                                        +$event.target.value
                                                    },
                                                    keydown: function (e) {
                                                      return (
                                                        _vm.invalidChars.includes(
                                                          e.key
                                                        ) && e.preventDefault()
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "slidecontainer" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "price-range-max price-range",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.translations.max)
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "vue-slider",
                                            _vm._b(
                                              {
                                                staticStyle: {
                                                  margin: "0 auto",
                                                  height: "150px",
                                                },
                                                attrs: { direction: "btt" },
                                                model: {
                                                  value: _vm.spotsRange,
                                                  callback: function ($$v) {
                                                    _vm.spotsRange = $$v
                                                  },
                                                  expression: "spotsRange",
                                                },
                                              },
                                              "vue-slider",
                                              _vm.spotsRangeOptions,
                                              false
                                            )
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "price-range-min price-range",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.translations.min)
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.filterElemsConfig.platform
                                ? _c(
                                    "section",
                                    {
                                      staticClass:
                                        "extended-section platform-section",
                                    },
                                    [
                                      _c(
                                        "form",
                                        {
                                          staticClass: "icon-search",
                                          on: {
                                            submit: function ($event) {
                                              $event.preventDefault()
                                            },
                                          },
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "form-control",
                                            attrs: { type: "search" },
                                            domProps: {
                                              value: _vm.platform_search,
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.platform_search =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.platforms,
                                        function (platform) {
                                          return _c(
                                            "div",
                                            {
                                              key: platform.pid,
                                              staticClass: "platform-check",
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "check-container",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(platform.pn) +
                                                      "\n                        "
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "checkbox-wrap",
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.selected_platforms,
                                                            expression:
                                                              "selected_platforms",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "checkbox",
                                                          name: "radio",
                                                        },
                                                        domProps: {
                                                          value: platform.pid,
                                                          checked: false,
                                                          checked:
                                                            Array.isArray(
                                                              _vm.selected_platforms
                                                            )
                                                              ? _vm._i(
                                                                  _vm.selected_platforms,
                                                                  platform.pid
                                                                ) > -1
                                                              : _vm.selected_platforms,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.selected_platforms,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v =
                                                                  platform.pid,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.selected_platforms =
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ]))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.selected_platforms =
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      ))
                                                              }
                                                            } else {
                                                              _vm.selected_platforms =
                                                                $$c
                                                            }
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass:
                                                          "checkmark",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "close btn",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.showFilterPopUp = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.translations.close) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "save btn active",
                              attrs: { type: "button" },
                              on: { click: _vm.applyFilter },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.translations.save) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.current_match &&
      _vm.current_match.isLoaded &&
      !_vm.is_contest_loading &&
      !_vm.selected_match_contests.length
        ? _c("div", { staticClass: "no-contest-section" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "no-contest-text" }, [
              _c("p", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.translations.no_contests_found)),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.current_match && _vm.current_match.isLoaded && !_vm.is_contest_loading
        ? _c(
            "div",
            { staticClass: "contest-list", staticStyle: { height: "auto" } },
            [
              _c(
                "virtual-list",
                {
                  attrs: { size: _vm.size, remain: _vm.remain, pagemode: true },
                },
                _vm._l(_vm.contest_list, function (contest_details) {
                  return _c("list-item", {
                    key: contest_details.cid,
                    attrs: {
                      contest_details: contest_details,
                      current_match: _vm.current_match,
                    },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "contest-list" },
            _vm._l([1, 2, 3, 4, 5], function (i) {
              return _c(
                "div",
                { key: i, staticClass: "contest-item img-1by1" },
                [_vm._m(1, true), _vm._v(" "), _vm._m(2, true)]
              )
            }),
            0
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-contest-thumbnail" }, [
      _c("img", {
        attrs: {
          src: "/static-assets/images/cssimages/no-contest-cham.png",
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contest-thumbnail isempty" }, [
      _c("div", { staticClass: "img-box" }, [
        _c("img", {
          staticClass: "lazy",
          attrs: {
            src: "/static-assets/images/cssimages/default-lazy.png",
            alt: "",
          },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contest-info" }, [
      _c("div", { staticClass: "info-wrap" }, [
        _c("div", { staticClass: "info-section1" }, [
          _c("div", { staticClass: "info-section-wrap" }, [
            _c("div", { staticClass: "name isempty" }),
            _vm._v(" "),
            _c("div", { staticClass: "price-detail isempty" }, [
              _c("span", { staticClass: "entry-fee" }),
              _vm._v(" "),
              _c("span", { staticClass: "spot" }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contest-rating isempty" }, [
            _c("span", { staticClass: "profit" }),
            _vm._v(" "),
            _c("span", { staticClass: "rating" }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-section2" }, [
          _c("span", { staticClass: "prize-pool isempty" }),
          _vm._v(" "),
          _c("span", { staticClass: "winning isempty" }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }